import React from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

const DirectorInformation = () => {
  const { jsonData } = useParams();

  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;
  return (
    <Container>
      <SectionInfo>
        <LabelArea>Director Information</LabelArea>
        <GreyArea>
          <Column>
            <Row>
              <div>Name</div>
              <div>{objectFyData?.name || 'N/A'}</div>
            </Row>
            <Row>
              <div>Identification submitted</div>
              <div>{objectFyData?.identificationSubmitted || 'N/A'}</div>
            </Row>
            <Row>
              <div>Uploaded ID</div>
              <div>{objectFyData?.uploadedID || 'N/A'}</div>
            </Row>
          </Column>

          <VerticalLine></VerticalLine>

          <Column>
            <Row>
              <div>Email address</div>
              <div>{objectFyData?.email || 'N/A'}</div>
            </Row>
            <Row>
              <div>Phone number</div>
              <div>{objectFyData?.phoneNumber || 'N/A'}</div>
            </Row>
          </Column>
        </GreyArea>
      </SectionInfo>
    </Container>
  );
};

export default DirectorInformation;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 8px;
`;

const GreyArea = styled.div`
  background-color: ${({ theme }) => theme.palette.tableBg};
  color: ${({ theme }) => theme.palette.grayTextColor};
  padding: 12px;
  grid-template-columns: 1fr 1px 1fr;
  display: grid;
  gap: 34px;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const LabelArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
  color: #232222;
`;

const VerticalLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: #d1d5db;

  @media (max-width: 884px) {
    display: none;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 140px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #6e7079;

  & > div:last-of-type {
    font-weight: 600;
    color: #2f3644;
  }

  @media (max-width: 884px) {
    gap: 16px;
  }
`;
